import { Type } from "@angular/core";
import { BespokeDashboardTile } from "../../../interfaces/bespoke-dashboard-tile";

export class DynamicTile {
    itemRefs: string[];
    constructor( public type: Type<BespokeDashboardTile>, ...itemRefs: Array<string>) {
        this.itemRefs = itemRefs;
     }
}